import React from 'react';
import { GeneralFila } from '../../../Models/General';
import FilaOrden from './FilaOrden';
import { Link } from 'react-router-dom';
import { conOrden } from '../../../Models/Compra';
import CardBuscador from '../../../Utiles/Buscadores/Card';
import { Producto } from '../../../Models/Productos';
import Avanzado, { AvanzadosProps } from '../../../Utiles/Componentes/Avanzado';
import { OrdenesContext } from '../../../Context/Compras/Ordenes';
import OrdenExcel from './Excel';
import { Col } from 'react-bootstrap';
class ListOrdenes extends CardBuscador {
    con = conOrden();
    placeholder = "BUSCAR ORDEN DE COMPRA";
    buscarEn = ["codigo", "nombre", 'fecha', 'rif'];
    fecha_init = 'dd/mm/aaaa';
    fecha_fin = 'dd/mm/aaaa';
    productos: Producto[] = []
    status = -1;
    user = -1;
    Avansado() {
        const { fecha_init, fecha_fin, status, user, productos, setAvanzados } = this;
        return <Avanzado setData={setAvanzados.bind(this)}
            estatus={['CANCELADO', 'EN ESPERA', 'PROCESADA']}
            fecha_init={fecha_init} fecha_fin={fecha_fin}
            status={status} user={user} productos={productos} />
    }
    setAvanzados({ fecha_init, fecha_fin, status, user, productos }: AvanzadosProps) {
        if (fecha_init) this.fecha_init = fecha_init;
        if (fecha_fin) this.fecha_fin = fecha_fin;
        if (user) this.user = user;
        if (status) this.status = status;
        if (status === 0) this.status = status;
        if (productos) this.productos = productos;
        this.forceUpdate()
    }
    filter() {
        const { fecha_init, fecha_fin, status, user, productos, datetonomber } = this;
        let itens = this.ordenar();
        return itens.filter((c: GeneralFila) => {
            if (c.status !== status && status !== -1) return false;
            if (c.usuario !== user && user !== -1) return false;
            const creacion = datetonomber(c.fecha);
            if (fecha_fin !== 'dd/mm/aaaa' && creacion > datetonomber(fecha_fin)) return false;
            if (fecha_init !== 'dd/mm/aaaa' && creacion < datetonomber(fecha_init)) return false;
            if (!productos.every(p => c.detalles.some(d => p.codigo === d))) return false;
            return true;
        });
    }
    Title() {
        return <>
            <h4 className='mr-auto'><i className="fa fa-search"></i> BUSCAR ORDEN DE COMPRA</h4>
            <Link to="/orden/nueva" className="btn btn-primary"><span className="fa fa-plus"></span> NUEVA ORDEN DE COMPRA</Link>
        </>
    }
    Row(p: GeneralFila) {
        return <FilaOrden  con={this.con} key={"cot" + p.codigo + p.status} data={p} />
    }
    Header() {
        const { Th } = this;
        return <tr className="info">
            <Th label='codigo' width='100px'>N°</Th>
            <Th label='fecha' width='120px'>FECHA</Th>
            <Th label='nombre' width='calc(100% - 585px)'>PROVEEDOR</Th>
            <Th width='160px'>MONTO</Th>
            <Th width='100px'>ESTATUS</Th>
            <Th width='135px'>ACCIONES</Th>
        </tr>
    }
    getItens() { return this.context.Ordenes; }
    set() { this.context.actOrden(); }
    getEstado() { return this.context.estOrdenes; }
    Actualizar() {
        const { hora } = this.getEstado();
        return <Col md={3} className='mr-auto d-flex flex-row-reverse'> 
            <OrdenExcel orden={this.filter()} />
            <div style={{ fontSize: '12px', width: "200px", paddingLeft: '15px' }}>
                <strong>ACTUALIZADO:</strong> <br />
                {hora}
            </div>
        </Col>
    }
}
ListOrdenes.contextType = OrdenesContext;
export default ListOrdenes;
